// import { dateFormatter, DateFormatTypes } from '@jfs/utils'

import { combineUserName } from '../../../util/util'

export const headers = {
  // id: '0',
  name: 'Name',
  email: 'Email',
  mobileNo: 'Mobile Number',
  department: 'Department',
  CreationDate: 'Created on',
  // ModifiedDate: 'Last Login',
  transactionStatus: 'Status',
  actions: 'Actions',
}

const returnFirstNameAsCapital = (status: string) => {
  //console.log('status', status)
  if (status?.toUpperCase() === 'TERMINATED') {
    return 'Deleted'
  }
  return status.charAt(0).toUpperCase() + status.slice(1)?.toLowerCase()
}

export const tableFormattedData = (
  users: any,
  getActionMenuComp: (status: any, user: any, hasSupersetPermission: boolean) => void,
  hasSupersetPermission = false,
) => {
  const formattedUserData = users.map((user: any) => {
    //console.log('formattedUserData', user)
    const userObj = user?.user
    return {
      id: user?.jfsUserId ?? '',
      name: combineUserName(userObj?.name),
      email: user?.email ?? 'NA',
      mobileNo: userObj?.mobile?.mobileNumber ?? 'NA',
      department: user.department ?? 'NA',
      CreationDate: user?.createdDate,
      // ModifiedDate: user?.lastLogin,
      transactionStatus: returnFirstNameAsCapital(user.status),
      // CreationDate: dateFormatter(user?.createdDate, DateFormatTypes.MONTH_STRING_ISO),
      // ModifiedDate: dateFormatter(user?.lastLogin, DateFormatTypes.MONTH_STRING_ISO),
      actions: getActionMenuComp(user?.status, user, hasSupersetPermission),
    }
  })
  return formattedUserData
}
